import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _5kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"5k"}/>
}
